import { createCustomEnum } from "./customEnum";

const ClosureReasonsHistorical = createCustomEnum({
	ApplicationDeclined: {
		value: "application_declined",
		name: "application_declined",
		displayName: "Application Declined",
	},
	Converted: {
		value: "converted",
		name: "converted",
		displayName: "Converted",
	},
	Other: {
		value: "other",
		name: "other",
		displayName: "Other",
	},
	RiskCreditHistory: {
		value: "risk_credit_history",
		name: "risk_credit_history",
		displayName: "Risk-Credit History",
	},
	RiskExcessAuths: {
		value: "risk_excess_auths",
		name: "risk_excess_auths",
		displayName: "Risk-Excess Auths",
	},
	RiskExcessOutParameters: {
		value: "risk_excess_out_parameters",
		name: "risk_excess_out_parameters",
		displayName: "Risk-Excess Out Paramts",
	},
	RiskExcessSalesDrafts: {
		value: "risk_excess_sales_drafts",
		name: "risk_excess_sales_drafts",
		displayName: "Risk-Excess Sales Drafts",
	},
	RiskNegativeInfo: {
		value: "risk_negative_info",
		name: "risk_negative_info",
		displayName: "Risk-Negative Info",
	},
	RiskMismatchUwRequests: {
		value: "risk_mismatch_uw_requests",
		name: "risk_mismatch_uw_requests",
		displayName: "Risk-Mismatch UW Rqts",
	},
});

export default ClosureReasonsHistorical;
